export default "__VITE_ASSET__C8DvDx0Q__"